  import React, { FC, useEffect, useState } from "react";
  import { Form, Select, Alert, FormInstance, Typography, Divider, message, Input } from "antd";
  import styled from "@emotion/styled";
  import UploadImages from "components/UploadImages";
  import { DetailRefundResponse, GetOrderDetailData, refundApproveInput, refundPaymentInput, refundPaymentList } from "services/interface";
  import { useDetailRefundList, useRefundPayment } from "hooks/useOrders";
  import { ObjectType } from "utils/convertData";
import { numberFormat } from "utils/nuberFormat";
import { allowFileExtensionsImage } from "config";
  const { Option } = Select;

  interface RefundPaymentDialogProps {
    form: FormInstance;
    item: GetOrderDetailData | undefined;
    onClose: () => void;
    refetchData: ()=> void;
    refund_process: string;
  }

  interface ResObjectType {
    [key: string]: ObjectType;
  }
  const ResPaymentType: ResObjectType = {
    promptpay: {
      th: "พร้อมเพย์",
      en: "promptpay",
    },
    // cash: {
    //   th: "เงินสด",
    //   en: "cash",
    // },
    manual_transfer: {
      th: "โอนเข้าบัญชีธนาคาร",
      en: "Manual transfer banking",
    },
  };
  const RefundPaymentDialog: FC<RefundPaymentDialogProps> = ({
    form,
    item,
    onClose,
    refetchData,
    refund_process
  }) => {
    const { mutate:refundPayment } = useRefundPayment();

    const [refundList, setRefundList] = useState<DetailRefundResponse>();
    const { mutate } = useDetailRefundList();

    useEffect(()=> {
        if (item) {
            mutate( item.order_id,
            {
                onSuccess: (data) => {
                    setRefundList(data)
                },
                onError: () => {
                    // message.error("ไม่มีข้อมูลการคืนเงิน");
                },
            });
        }    
    },[item]);
    
    const childrenRefund: React.ReactNode[] = [];
    Object.entries(ResPaymentType).forEach(([key, value]) => {
      childrenRefund.push(
        <Option key={key} value={key}>
          {value.th}
        </Option>
      );
    });
    const onFinish = (values: any ) => {
      const refundList:refundPaymentList[] = [{
        amount: values.payment_amount,
        image_slip: Array.isArray(values.image) && values.image.length > 0 ? values.image[0]?.url : null,
      }] ;
      const refundPaymentData:refundPaymentInput = {
        order_id: item?.order_id || '',
        payment_amount: refund_process === 'overpay' ? item?.final_price || 0 : item?.factory_refund || 0,
        payment_type: values.refund_type,
        refund_process: refund_process, 
        vat_percent: 7,
        payment_list: refundList,
      }
      refundPayment(refundPaymentData, {
        onSuccess: (res) => {
          if (res.status === "success") {
            message.success("ยืนยันการคืนเงินสำเร็จ");
            refetchData();
            onClose();
            form.resetFields();
          } else {
            message.error(`ยืนยันการคืนเงินไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`ยืนยันการคืนเงินไม่สำเร็จ: ${error.message}`);
        },
      });
    }

    return (
        <Form form={form} onFinish={onFinish}>
          <FormItems
            labelAlign="left"
            label="ชื่อลูกค้า"
          >
            <Typography.Text>{item?.address_name}</Typography.Text>
          </FormItems>
          <FormItems
            labelAlign="left"
            label="ที่อยู่"
          >
            <Typography.Text>{item?.address_text}</Typography.Text>
          </FormItems>
          <FormItems
            labelAlign="left"
            label="เบอร์โทรศัพท์"
          >
            <Typography.Text strong>{item?.address_telephone}</Typography.Text>
          </FormItems>
          {refund_process === "overpay" ?
            <FormItems
              labelAlign="left"
              label="จำนวนเงินที่ต้องคืน"
            >
              <Typography>{numberFormat(item?.final_price || 0)} {" "} บาท</Typography>
            </FormItems>
            :
            <FormItems
              labelAlign="left"
              label="จำนวนเงินที่ต้องคืน"
            >
              <Typography>{numberFormat(item?.factory_refund || 0)} {" "} บาท</Typography>
            </FormItems>
          }
          <DividerFit/>
          <Form.Item 
            label="ช่องทางการคืนเงิน"  
            labelAlign="left" 
            name="refund_type" 
            rules={[{ required: true, message: "กรุณาเลือกช่องทางการคืนเงิน" }]}
          >
            <Select
              placeholder="ช่องทางการคืนเงิน"
              optionFilterProp="children"
            >
              {childrenRefund}
            </Select>
          </Form.Item>
          <Form.Item
            labelAlign="left"
            label="ระบุจำนวนที่โอน"
            name="payment_amount"
            rules={[
              {
                required: true,
                message: "ระบุจำนวนที่โอน",
              },
            ]}
          >
            <Input
              placeholder="ระบุจำนวนที่โอน"
              size="small"
              // defaultValue={item?.final_price}
              type="number" />
          </Form.Item>
          <Form.Item label="แนบรูปภาพ" name="image" rules={[{ required: false, message: "กรุณาแนบรูปภาพ" }]}>
            <UploadImages maximumUploadItems={1} allowFileExtensions={allowFileExtensionsImage} typeUpload="slip"/>
          </Form.Item>
          <Alert
            message="ข้อควรปฎิบัติ และ แจ้งเตือน"
            description="กรุณาตรวจสอบข้อมูล และ เลือกข้อมูลการคืนเงินอย่างละเอียดก่อนกดปุ่ม 'ยืนยัน'"
            type="warning"
            showIcon
          />
        </Form>
    );
  };

  export default RefundPaymentDialog;

  const FormItems = styled(Form.Item)`
    margin-bottom: 0;
    width: 100%;
  `;
  const DividerFit = styled(Divider)`
    margin: 10px;
  `;

